export const isAddressCellEditable = ({ field, row }) => {
  if (field === 'adressType' && !row?.isNew) return false;

  return true;
};

export const getAddressTableEditableFields = (apiRef, rowId) => {
  const allCols = apiRef.current.getVisibleColumns?.() ?? [];
  const row = apiRef.current.getRow?.(rowId);

  const editableFields = allCols
    .filter((c) => c.type !== 'actions' && c.editable)
    .filter((c) => {
      return isAddressCellEditable({ field: c.field, row });
    })
    .map((c) => c.field);

  return editableFields;
};

export const getTableEditableFields = (apiRef) => {
  const allCols = apiRef.current.getVisibleColumns?.() ?? [];

  const editableFields = allCols.filter((c) => c.type !== 'actions' && c.editable).map((c) => c.field);

  return editableFields;
};

export const normalizeBankDefaults = (rows, preferredDefaultId = null) => {
  const normalizedRows = rows.map((row) => ({ ...row }));
  const currencyGroups = new Map();

  normalizedRows.forEach((row, index) => {
    const currencyCode = row.currencyCode ?? '';
    currencyGroups.set(currencyCode, [...(currencyGroups.get(currencyCode) ?? []), index]);
  });

  currencyGroups.forEach((indexes) => {
    const preferredIndex = indexes.find((index) => normalizedRows[index].id === preferredDefaultId);
    const currentDefaultIndex = indexes.find((index) => normalizedRows[index].default);
    const defaultIndex = preferredIndex ?? currentDefaultIndex ?? indexes[0];

    indexes.forEach((index) => {
      normalizedRows[index].default = index === defaultIndex;
    });
  });

  return normalizedRows;
};
